import React, { Component } from "react";
import { Button ,Icon ,Modal, message, Tooltip } from "antd";
import Fetch from "../../../common/Fetch";
import ExportUtil from  '../../../common/ExportUtil'
import API_URL from "../../../common/url";
import Filter from "./Filter";
import TableC from "../../basicElement/TableC";
import $ from '../../../common/AjaxRequest';
import SideNav from "../SideNav";
import format from "../../shared/format";

class Personal extends Component {
    state = {
        data: [],
        loading: false,
        sortParams: {},
        searchParams:{},
        pagination: {
            pageSize: 10,
            current: 1,
        },
    }

    loadData = () => {
        const {searchParams, pagination } = this.state;
        const { current, pageSize } = pagination;
        this.setState({ loading: true });
        const options = {
            method: 'POST',
            url: API_URL.dashboard.queryCrcIncomeList,
            data: {
                offset: current,
                limit: pageSize,
                ...searchParams,
            },
            dataType: 'json',
            doneResult: res => {
                const { datas, totalCount } = res;
                pagination.total = totalCount;
                this.setState({
                    loading: false,
                    data: datas,
                    pagination
                });
            }
        };
        $.sendRequest(options);
    };

    search = (searchParams) => {
        const { pagination = {} } = this.state;
        pagination.current = 1;
        this.setState({searchParams,pagination},
            () => {
                this.loadData();
            }
        );
    };

    export = (searchParams) => {
        const { areaParams } = searchParams;
        const {pagination } = this.state;
        const { current, pageSize } = pagination;
        const options = {
            method: 'POST',
            url: API_URL.dashboard.exportCrcIncomeList,
            data: {
                offset: current,
                limit: pageSize,
                ...searchParams,
                ...areaParams
            },
            dataType: 'json',
            doneResult: res => {
                message.success(res.success)
            }
        };
        $.sendRequest(options);
    };

    getColumns = () => {
        const columns = [
            {
                title: '收入确认时间',
                dataIndex: 'yearMonthNum',
                key: 'yearMonthNum',
                width: 100,
                fixed: 'left',
            },{
                title: '姓名',
                dataIndex: 'userCompellation',
                key: 'userCompellation',
                width: 100,
                fixed: 'left',
            },{
                title: '工号',
                dataIndex: 'employeeCode',
                key: 'employeeCode',
                width: 100,
                fixed: 'left',
            },{
                title: '区域',
                dataIndex: 'areaName',
                key: 'areaName',
                width: 100,
            },{
                title: '工作城市',
                dataIndex: 'workCity',
                key: 'workCity',
                width: 100,
            },{
                title: '部门',
                dataIndex: 'enterpriseDepartmentName',
                key: 'enterpriseDepartmentName',
                width: 100,
            },{
                title: '职位',
                dataIndex: 'positionName',
                key: 'positionName',
                width: 100,
            },{
                title: '直线主管姓名',
                dataIndex: 'leaderUser',
                key: 'leaderUser',
                width: 100,
            },{
                title: '直线主管工号',
                dataIndex: 'leaderCode',
                key: 'leaderCode',
                width: 100,
            },{
                title: '状态',
                dataIndex: 'status',
                key: 'status',
                width: 100,
            },{
                title: '参与项目数',
                dataIndex: 'invNum',
                key: 'invNum',
                width: 100,
            },{
                title: '项目角色',
                dataIndex: 'roleCode',
                key: 'roleCode',
                width: 100,
            },{
                title: '单月计划FTE',
                dataIndex: 'planFte',
                key: 'planFte',
                width: 100,
            },{
                title: '实际单月消耗FTE',
                dataIndex: 'consumeFte',
                key: 'consumeFte',
                width: 100,
            },{
                title: '实际单月入组例数',
                dataIndex: 'thisAmount',
                key: 'thisAmount',
                width: 100,
            },{
                title: '实际单月标准访视数量',
                dataIndex: 'thisStandardAmount',
                key: 'thisStandardAmount',
                width: 100,
            },{
                title: (
                    <span>
                        当年累计消耗FTE
                        <Tooltip overlayStyle={{ width: 160 }} placement="top" title={'上年度12/26~本月25号计入完工的项目确认FTE'}>
                            <a><Icon style={{  marginLeft: 6, fontSize: '14px' }} type="info-circle-o" /></a>
                        </Tooltip>
                    </span>
                ),
                dataIndex: "yearConsumeFte",
                key: "yearConsumeFte",
                width: 80,
            },{
                title: (
                    <span>
                        当年累计入组例数
                        <Tooltip overlayStyle={{ width: 160 }} placement="top" title={'上年度12/26~本月25号随机入组数量'}>
                            <a><Icon style={{  marginLeft: 6, fontSize: '14px' }} type="info-circle-o" /></a>
                        </Tooltip>
                    </span>
                ),
                dataIndex: "yearRandomAmount",
                key: "yearRandomAmount",
                width: 80,
            },{
                title: (
                    <span>
                        当年累计标准访视数量
                        <Tooltip overlayStyle={{ width: 160 }} placement="top" title={'上年度12/26~本月25号标准访视数量'}>
                            <a><Icon style={{  marginLeft: 6, fontSize: '14px' }} type="info-circle-o" /></a>
                        </Tooltip>
                    </span>
                ),
                dataIndex: "yearStandardAmount",
                key: "yearStandardAmount",
                width: 80,
            },{
                title: (
                    <span>
                        历年累计消耗FTE
                        <Tooltip overlayStyle={{ width: 160 }} placement="top" title={'项目开始~本月25号计入完工的项目确认FTE'}>
                            <a><Icon style={{  marginLeft: 6, fontSize: '14px' }} type="info-circle-o" /></a>
                        </Tooltip>
                    </span>
                ),
                dataIndex: 'accumulativeFte',
                key: 'accumulativeFte',
                width: 100,
            },{
                title: (
                    <span>
                        历年累计标准访视数量
                        <Tooltip overlayStyle={{ width: 160 }} placement="top" title={'项目开始~本月25号标准访视数量'}>
                            <a><Icon style={{  marginLeft: 6, fontSize: '14px' }} type="info-circle-o" /></a>
                        </Tooltip>
                    </span>
                ),
                dataIndex: 'accumulativeStandardAmount',
                key: 'accumulativeStandardAmount',
                width: 100,
            },{
                title: (
                    <span>
                        历年累计入组例数
                        <Tooltip overlayStyle={{ width: 160 }} placement="top" title={'项目开始~本月25号随机入组数量'}>
                            <a><Icon style={{  marginLeft: 6, fontSize: '14px' }} type="info-circle-o" /></a>
                        </Tooltip>
                    </span>
                ),
                dataIndex: 'accumulativeRandomAmount',
                key: 'accumulativeRandomAmount',
                width: 100,
            },{
                title: (
                    <span>
                        累计收入不含税/人民币
                        <Tooltip overlayStyle={{ width: 160 }} placement="top" title={'项目开始~本月收入不含税/人民币'}>
                            <a><Icon style={{  marginLeft: 6, fontSize: '14px' }} type="info-circle-o" /></a>
                        </Tooltip>
                    </span>
                ),
                dataIndex: 'accumulativeIncomeAmount',
                key: 'accumulativeIncomeAmount',
                width: 100,
                render: text => format('money', text),
            },{
                title: '累计上月收入不含税/人民币',
                dataIndex: 'accumulativeLastIncomeAmount',
                key: 'accumulativeLastIncomeAmount',
                width: 100,
                render: text => format('money', text),
            },{
                title: '当月服务费收入不含税/人民币',
                dataIndex: 'incomeAmount',
                key: 'incomeAmount',
                width: 100,
                render: text => format('money', text),
            },{
                title: (
                    <span>
                        当年服务费收入不含税/人民币
                        <Tooltip overlayStyle={{ width: 160 }} placement="top" title={'本年度1月~本月收入不含税/人民币'}>
                            <a><Icon style={{  marginLeft: 6, fontSize: '14px' }} type="info-circle-o" /></a>
                        </Tooltip>
                    </span>
                ),
                dataIndex: 'yearIncomeAmount',
                key: 'yearIncomeAmount',
                width: 100,
                render: text => format('money', text),
            }
        ];
    return columns;
    };

    handleTableChange = (params) => {
        this.setState({
            ...params,
        }, () => {
            this.loadData();
        });
    }

    render() {
        const {
            data,
            loading,
            pagination,
            sortParams,
        } = this.state;
        return (
            <div>
                <Filter
                    search={this.search}
                    export={this.export}
                />
                <TableC
                    data={data}
                    scrollY={500}
                    loading={loading}
                    sortParams={sortParams}
                    columns={this.getColumns()}
                    pagination={pagination}
                    onChange={this.handleTableChange}
                />
            </div>
        );
    }
}

export default Personal;



// WEBPACK FOOTER //
// ./src/components/financeManagement/IncomeReport/Personal.js